import { environment } from '@environment';

const BASE_URL_ICONS = `${environment.cloudinaryURL}travel/shared/icons/`;
const BASE_URL_TRIP_TYPES_INTERESTS = `${environment.cloudinaryURL}travel/shared/trip-types-interests/`;
export const ICONS = [
  {
    name: 'arts-culture',
    link: `${BASE_URL_TRIP_TYPES_INTERESTS}arts-culture.svg`,
  },
  {
    name: 'fashion-shopping',
    link: `${BASE_URL_TRIP_TYPES_INTERESTS}fashion-shopping.svg`,
  },
  {
    name: 'food-wine',
    link: `${BASE_URL_TRIP_TYPES_INTERESTS}food-wine.svg`,
  },
  {
    name: 'health-wellness',
    link: `${BASE_URL_TRIP_TYPES_INTERESTS}health-wellness.svg`,
  },
  {
    name: 'nature-outdoors',
    link: `${BASE_URL_TRIP_TYPES_INTERESTS}nature-outdoors.svg`,
  },
  {
    name: 'sports-adventure',
    link: `${BASE_URL_TRIP_TYPES_INTERESTS}sports-adventure.svg`,
  },
  {
    name: 'couple',
    link: `${BASE_URL_TRIP_TYPES_INTERESTS}couple.svg`,
  },
  {
    name: 'family',
    link: `${BASE_URL_TRIP_TYPES_INTERESTS}family.svg`,
  },
  {
    name: 'friends',
    link: `${BASE_URL_TRIP_TYPES_INTERESTS}friends.svg`,
  },
  {
    name: 'solo',
    link: `${BASE_URL_TRIP_TYPES_INTERESTS}solo.svg`,
  },
  {
    name: 'business',
    link: `${BASE_URL_TRIP_TYPES_INTERESTS}business.svg`,
  },
  {
    name: 'add-white',
    link: `${BASE_URL_ICONS}add-white.svg`,
  },
  {
    name: 'arrow',
    link: `${BASE_URL_ICONS}arrow.svg`,
  },
  {
    name: 'chevron-right',
    link: `${BASE_URL_ICONS}chevron-right.svg`,
  },
  {
    name: 'dropdown-close',
    link: `${BASE_URL_ICONS}dropdown-close.svg`,
  },
  {
    name: 'icon-status-confirmed',
    link: `${BASE_URL_ICONS}icon-status-confirmed.svg`,
  },
  {
    name: 'add',
    link: `${BASE_URL_ICONS}add.svg`,
  },
  {
    name: 'back',
    link: `${BASE_URL_ICONS}back.svg`,
  },
  {
    name: 'close',
    link: `${BASE_URL_ICONS}close.svg`,
  },
  {
    name: 'dropdown-open',
    link: `${BASE_URL_ICONS}dropdown-open.svg`,
  },
  {
    name: 'info',
    link: `${BASE_URL_ICONS}info.svg`,
  },
  {
    name: 'arrow-right-mobile',
    link: `${BASE_URL_ICONS}arrow-right-mobile.svg`,
  },
  {
    name: 'call',
    link: `${BASE_URL_ICONS}call.svg`,
  },
  {
    name: 'document',
    link: `${BASE_URL_ICONS}document.svg`,
  },
  {
    name: 'gallery-arrow-next',
    link: `${BASE_URL_ICONS}gallery-arrow-next.svg`,
  },
  {
    name: 'present',
    link: `${BASE_URL_ICONS}present.svg`,
  },
  {
    name: 'arrow-right',
    link: `${BASE_URL_ICONS}arrow-right.svg`,
  },
  {
    name: 'chevron-left',
    link: `${BASE_URL_ICONS}chevron-left.svg`,
  },
  {
    name: 'download',
    link: `${BASE_URL_ICONS}download.svg`,
  },
  {
    name: 'gallery-arrow-prev',
    link: `${BASE_URL_ICONS}gallery-arrow-prev.svg`,
  },
];
